<template lang="pug">
  .Register
    transition(name="slide" mode="out-in")
      keep-alive
        component(
        :form="form"
        :is="step"
        @onNext="next"
        @onBack="step= 'FormUser'"
        @onSubmit="onSubmitClick")

</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import FormUser from './form-user'
  import FormSuccess from './form-success'

  const TR_LANG_CODE = 'tr'
  const TR_CURRENCY_CODE = "TRY"
  const EURO_CURRENCY_CODE = "EUR"

  export default {
    name: 'Register',

    inject: ['$validator'],

    components: {
      FormUser,
      FormSuccess
    },

    data() {
      return {
        step: 'FormUser',
        form: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          password: null,
          password_again: null,
          merchant_name: null,
          merchant_type: '-1',
          captcha_response: null,
          language_code: null,
          language_name: null,
          currency_code: null,
          currency_name: null,
          currency_symbol: null,
          timezone_code: null,
          timezone_name: null
        }
      }
    },

    computed: {

      ...mapGetters('App', [
        'is_production',
        'lang_default'
      ]),
    },

    watch: {
      'form.password'(val) {
        this.form.password_again = val
      }
    },

    created() {
    },

    methods: {
      ...mapActions('Auth', [
        'createUser'
      ]),

      ...mapMutations('Auth', [
        'UPDATE_FORGOT_PASS_SUCCESS'
      ]),

      next() {
        this.onSubmitClick()
      },

      async onSubmitClick () {
        if (this.is_production)
          this.$refs.invisibleRecaptcha.execute()
        else
          this.submit()
      },

      submit () {
        this.createUser(this.form)
        .then(() => {
          this.step = 'FormSuccess'
        })
        .catch(err => {
          // this.showErrorToast(this.$getErrorMessage(this, err))
          // this.$refs.invisibleRecaptcha.reset()
        })
      },

      onCaptchaVerify(response) {
        this.form.captcha_response = response
        this.submit()
      },

      setDefaults() {
        this.form.language_code = this.lang_default
        if(this.lang_default === TR_LANG_CODE)
          this.form.currency_code = TR_CURRENCY_CODE
        else 
          this.form.currency_code = EURO_CURRENCY_CODE
      }

    },

    beforeMount() {
      const lang = this.$route.params.lang
      if (lang) 
        this.langChange({ lang : lang })
    },

    mounted() {
      this.UPDATE_FORGOT_PASS_SUCCESS(false)
      this.setDefaults()
    }

  }
</script>

<style lang="scss" scoped>
  .Register {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    @media only screen and(max-height: 600px) {
      height: auto;
      align-items: flex-start;
      padding-top: 150px;
      padding-bottom: 50px;
    }

    /deep/ {

      .body {
        position: relative;
        width: 660px;

        &.form-success {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .success-circle {
            margin-bottom: 50px;
          }

          .header {
            .desc {
              margin-top: 20px;
            }
          }
        }

        &.form-merchant {

          .content {
            width: 660px;
            margin: auto;

            .form {
              display: grid;
              grid-template-columns: 1fr 1fr;
              grid-column-gap: 30px;

              .row {
                margin-top: 40px;
              }

              .inline {
                margin-left: 0 !important;
              }
            }
          }
        }

        .back-btn {
          cursor: pointer;
          transition: all .1s;
          color: #B6B7B8;
          margin-left: 5px;
          margin-top: 5px;

          &:hover {
            transform: scale(1.05);
          }

          @media only screen and(max-width: 500px) {
            position: fixed;
            top: 80px;
            left: 25px;
          }
        }

        .header {
          margin-bottom: 20px;
          text-align: center;

          .desc {
            margin-top: 35px;
          }

          .top {
            display: flex;
            text-align: center;
            align-items: center;

            .title {
              flex-grow: 1;
              margin-right: 55px;

              @media only screen and(max-width: 500px) {
                margin-right: 0;
                font-size: 26px;
              }
            }
          }
        }

        .content {
          width: 100%;

          .form {
            display: flex;
            flex-direction: column;

            .row {
              display: flex;
              width: 100%;
              margin-top: 80px;
              justify-content: center;

              .inline {
                flex-grow: 1;

                &:last-child {
                  margin-left: 40px;
                }

                &.password {
                  position: relative;
                }
              }

              &.submit {
                .btn {
                  width: 400px;

                  @media only screen and(max-width: 767px) {
                    width: 100%;
                  }
                }
              }
            }
          }
        }

        .footer {
          max-width: 360px;
          margin-left: auto;
          margin-right: auto;
          margin-top: 50px;
          text-align: center;

          @media only screen and(max-width: 767px) {
            max-width: unset;
            width: 80%;
          }
        }

        @media only screen and(max-width: 767px) {
          & {
            width: 80%;
          }

          &.form-merchant {
            width: 80%;

            .content {
              width: 100%;
            }
          }
        }
      }
    }

  }
</style>
